<template>
  <div class="business">
    <menuBox :step="3"></menuBox>
    <div class="about-box">
      <div class="msg">
        SUPERIOR ALWAYS LIMITED 以卓越的數字營銷解決方案和創新的廣告策略而脫穎而出。憑藉著多年的行業經驗和卓越的專業團隊，我們成功地幫助客戶實現品牌目標，提升曝光度，並在競爭激烈的市場中取得成功。
        <br />
        <br />
        公司致力於為客戶提供最優質的服務。我們深知每個品牌的獨特性，因此我們以客製化的解決方案回應客戶的具體需求。無論您是一家初創企業還是一個已經在市場上建立了存在感的品牌，我們都能為您提供適切的支持，助您取得更大的成功。
      </div>
    </div>
    <div class="detail-box">
      <div class="title">
        想要了解更多詳情嗎？請參閱以下我們的案例分享和常見問題解答！
      </div>
      <div class="left">
        <div class="tit">
          成功案例分享
        </div>
        <div class="msg">
          深入了解我們與客戶之間的成功合作案例，重點展示我們提供的解決方案在實際業務中取得的顯著成果，為您提供實際的業績參考。
        </div>
      </div>
      <div class="right">
        <div class="tit">
          常見問題解答
        </div>
        <div class="msg">
          我們為您準備了詳細的常見問題解答，幫助您更全面地了解我們的服務、流程以及可能涉及的其他問題。
        </div>
      </div>
    </div>
    <div class="partner-box">
      <div class="title">
        客戶
      </div>
      <div class="partner-list">
        <img src="../assets/icon-1.png" alt="" />
        <img src="../assets/icon-2.png" alt="" />
        <img src="../assets/icon-3.png" alt="" />
        <img src="../assets/icon-4.png" alt="" />
        <img src="../assets/icon-5.png" alt="" />
        <img src="../assets/icon-6.png" alt="" />
      </div>
    </div>
    <div class="appointment-box">
      <div class="sub-box">
        <input type="text" placeholder="你的名字" />
        <input type="text" placeholder="你的郵件" />
        <textarea class="message" type="text" placeholder="訊息" />
        <div class="btn" @click="submit()">預約</div>
      </div>
    </div>
    <footerBox></footerBox>
  </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
  name: "App",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    aboutUs() {
      this.$router.push({ path: "aboutUs" });
    },
    submit(){
        alert('Success')
    }
  },
};
</script>
<style lang="less" scoped>
.about-box {
  background-image: url(../assets/us-1.png);
  width: 100%;
  height: 750px;
  background-size: 100% 100%;
  overflow: hidden;
  color: #333333;
  .msg {
    font-size: 18px;
    font-family: Roboto-Light, Roboto;
    font-weight: 300;
    color: #333333;
    max-width: 680px;
    margin-left: 620px;
    margin-top: 260px;
  }
}
.detail-box {
  background-image: url(../assets/us-2.png);
  height: 1020px;
  background-size: 100% 100%;
  overflow: hidden;
  text-align: left;
  padding: 0 360px;
  margin-top: 100px;
  .title {
    font-size: 40px;
    font-family: Roboto-Bold, Roboto;
    font-weight: bold;
    color: #333333;
    max-width: 615px;
    margin-top: 150px;
  }
  .tit {
    font-size: 40px;
    font-family: Roboto-Bold, Roboto;
    font-weight: bold;
    color: #333333;
    margin-bottom: 24px;
  }
  .msg {
    font-size: 18px;
    font-family: Roboto-Regular, Roboto;
    font-weight: 400;
    color: #333333;
  }
  .left {
    float: left;
    margin-top: 370px;
    max-width: 516px;
    margin-left: 30px;
  }
  .right {
    float: right;
    max-width: 516px;
    margin-top: 370px;
    margin-right: 20px;
  }
}
.partner-box {
  height: 400px;
  width: 100%;
  .title {
    font-size: 40px;
    font-family: Roboto-Bold, Roboto;
    font-weight: bold;
    color: #333333;
    text-align: center;
    margin-top: 150px;
  }
  .partner-list {
    padding: 0 360px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 60px;
    img {
      width: 180px;
      height: 80px;
    }
  }
}
.appointment-box {
  padding: 0 360px;
  height: 650px;
  background-image: url(../assets/us-3.png);
  background-size: 100% 100%;
  overflow: hidden;
  .sub-box {
    width: 520px;
    height: 370px;
    padding: 40px;
    float: right;
    background-color: #fff;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.08);
    margin-top: 100px;
    border-radius: 8px;
    input,
    textarea {
      background-color: #f5f5f5;
      width: 480px;
      padding: 0 20px;
      border-radius: 8px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      height: 48px;
      border: none;
      margin-bottom: 20px;
    }
    .message {
      height: 120px;
      padding: 20px;
    }
    .btn {
      width: 100%;
      height: 56px;
      background: #53ba27;
      border-radius: 4px;
      line-height: 56px;
      text-align: center;
      color: #fff;
      cursor: pointer;
    }
  }
}
</style>
